module.exports = __webpack_public_path__ + "img/philosophy-examined-cover.2f1c3df1.jpg";